import { Platform } from '@ionic/angular'
import { Requestor, StorageBackend } from '@openid/appauth'
import { Browser } from 'ionic-appauth'
import { App } from '@capacitor/app'
import { NgZone } from '@angular/core'
import { environment } from '@env'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Store } from '@ngrx/store'
import { authorizationCallback, endSessionCallback, onAuthEventChange } from '@core/store/actions/auth.actions'
import { CoreAuthService } from '../services/core-auth-service'
import { buildIdentityServerSettings } from '../utils/auth.utils'

export const authFactory = (
  platform: Platform,
  ngZone: NgZone,
  browser: Browser,
  storage: StorageBackend,
  requestor: Requestor,
  _store: Store
) => {
  const authService = new CoreAuthService(browser, storage, requestor)
  authService.authConfig = buildIdentityServerSettings(environment.identityServerConfig(platform.is('capacitor')))

  if (platform.is('capacitor')) {
    void App.addListener('appUrlOpen', (data: any) => {
      if (data.url !== undefined) {
        ngZone.run(() => {
          if (data.url.indexOf(authService.authConfig.redirect_url) === 0) {
            _store.dispatch(authorizationCallback({ url: data.url }))
          } else if (data.url.indexOf(authService.authConfig.end_session_redirect_url) === 0) {
            _store.dispatch(endSessionCallback({ navigateUrl: data.url.replace(environment.urlScheme, '') }))
          }
        })
      }
    })
  }

  authService.events$
    .pipe(takeUntilDestroyed())
    .subscribe((authEventAction) => _store.dispatch(onAuthEventChange({ event: authEventAction })))

  return authService
}
